export default "assets/images/icons/slider-arrow-59bee018.svg";